import { render, staticRenderFns } from "./register.vue?vue&type=template&id=39e00dda&"
import script from "./register.vue?vue&type=script&lang=ts&"
export * from "./register.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports